<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-3 pt-3 pr-3" style="height: 80vh">
      <template>
        <!-- <v-row>
          <v-col cols="12">
            <v-text-field
              ref="name"
              v-model="commissionForm.name"
              label="Nombre"
              outlined
              :rules="[
                () => !!commissionForm.name || 'Es necesario ingresar un nombre',
              ]"
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
        </v-row> -->

        <!-- <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="commissionForm.description"
                            outlined
                            label="Descripción"
                            >
                        </v-textarea>
                    </v-col>
                </v-row> -->
        <v-col cols="12">
          <v-autocomplete
            ref="metodo_pago"
            :value="commissionForm.metodo_pago"
            v-model="commissionForm.metodo_pago"
            :items="metodoPago"
            label="Metodo de pago"
            outlined
            :item-text="customText"
            item-value="name"
            :rules="[
              () =>
                !!commissionForm.metodo_pago ||
                'Es necesario seleccionar un Metodo de pago',
            ]"
            hide-details="auto"
            required
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" v-if="commissionForm.metodo_pago == 'CAJA'">
          <v-autocomplete
            ref="sucursal"
            :value="commissionForm.sucursal_id"
            v-model="commissionForm.sucursal_id"
            :items="offices"
            label="Sucursal"
            outlined
            :item-text="customText"
            item-value="id"
            @change="changeSucursal()"
            hide-details="auto"
            required
          ></v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          v-if="
            commissionForm.sucursal_id != null &&
              commissionForm.metodo_pago == 'CAJA'
          "
        >
          <v-autocomplete
            ref="categoria"
            :value="commissionForm.caja_id"
            v-model="commissionForm.caja_id"
            :items="tills"
            label="Caja"
            outlined
            :item-text="customText"
            item-value="id"
            hide-details="auto"
            required
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" v-if="commissionForm.metodo_pago == 'CUENTA BANCARIA'">
          <v-autocomplete
            ref="sucursal"
            :value="commissionForm.account_id"
            v-model="commissionForm.account_id"
            :items="accounts"
            label="Cuenta Bancaria"
            outlined
            :item-text="customTextDescription"
            item-value="id"
            hide-details="auto"
            required
          ></v-autocomplete>
        </v-col>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn block height="40" dark color="red" @click="handleCancel">
              <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              v-if="action == 'create'"
              dark
              color="success"
              block
              height="40"
              @click="handleStore"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Guardar
            </v-btn>
            <v-btn
              v-if="action == 'update'"
              dark
              color="success"
              block
              height="40"
              @click="handleUpdate"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Pagar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "CreateUpdate",
  data() {
    return {
      drawer: false,
      titleForm: null,
      action: null,
      commissionForm: {
        id: null,
        metodo_pago: null,
        sucursal_id: null,
        caja_id: null,
        account_id: null,
        amount: null,
        fullname: null,
      },
      metodoPago: [{ name: "CAJA" }, { name: "CUENTA BANCARIA" }],
    };
  },
  computed: {
    ...mapState("tills", ["tills"]),
    ...mapState("offices", ["offices"]),
    ...mapState("accounts", ["accounts"]),
  },

  methods: {
    ...mapActions("brands", ["store", "update"]),
    ...mapActions("tills", ["getTills"]),
    ...mapActions("comisiones", ["change_pagar"]),
    customText(item) {
      let text = item.name;
      return text;
    },
    // resetData(){
    //     this.commissionForm = {
    //     id: null,
    //     metodo_pago: null,
    //     sucursal_id: null,
    //     caja_id: null,
    //     account_id: null,
    //     name: null,
    //     description: null,
    //   }
    // },
    customTextDescription(item) {
      let text = item.type + " - " + item.number_account;
      //   let text = item.description;
      return text;
    },
    async showForm(title, action, commission = null) {
      await this.clearData();
      this.titleForm = title;
      this.action = action;
      if (commission) {
        this.setBrand(commission);
      }
      this.drawer = !this.drawer;
    },
    clearData() {
      this.titleForm = null;
      this.action = null;
      this.commissionForm.id = null;
      this.commissionForm.name = null;
      this.commissionForm.description = null;
      this.clearErrors();
    },
    setBrand(commission) {
      // console.log("==>>>", commission);
      this.commissionForm.id = commission.id;
      this.commissionForm.name = commission.name;
      this.commissionForm.description = commission.description;
      if (commission.direct) {
        this.commissionForm.amount = commission.amount;
      } else {
        this.commissionForm.amount =
          (commission.amount * commission.price) / 100;
      }
      this.commissionForm.fullname = commission.doctor_fullname;
    },
    closeForm() {
      this.clearData();
      this.drawer = false;
    },
    handleCancel() {
      this.closeForm();
    },
    async handleStore() {
      if (!this.existErrors()) {
        await this.store(this.commissionForm);
        this.closeForm();
      }
    },
    async handleUpdate() {
      //   if (!this.existErrors()) {

      let form = {
        id: this.commissionForm.id,
        metodo_pago: this.commissionForm.metodo_pago,
        amount: this.commissionForm.amount,
        fullname: this.commissionForm.fullname,
      };
      if (this.commissionForm.metodo_pago == "CAJA") {
        form = {
          ...form,
          sucursal_id: this.commissionForm.sucursal_id,
          caja_id: this.commissionForm.caja_id,
        };
      } else if (this.commissionForm.metodo_pago == "CUENTA BANCARIA") {
        form = {
          ...form,
          account_id: this.commissionForm.account_id,
        };
      }
      await this.change_pagar(form);
      // this.closeForm();
      //   }
    },
    existErrors() {
      let hasErrors = false;

      Object.keys(this.commissionForm).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.commissionForm[f]) hasErrors = true;
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    clearErrors() {
      Object.keys(this.commissionForm).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
    async changeSucursal() {
      if (this.commissionForm.sucursal_id) {
        await this.getTills({ office_id: this.commissionForm.sucursal_id });
      }
    },
  },
};
</script>

<style scoped></style>
